var React = require('react');

function Win10 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M41.4 19.5879H19.1271V3.11133L41.4 0V19.5879ZM17.5425 3.33244V19.5879H0.599976V5.70147L17.5425 3.33244ZM19.1271 21.1713V37.6926L41.4 40.8V21.1713H19.1271ZM0.599976 21.1713H17.5425V37.4715L0.599976 35.1077V21.1713Z","fill":"#0079D7"}));
}

Win10.defaultProps = {"width":"42","height":"41","viewBox":"0 0 42 41","fill":"none"};

module.exports = Win10;

Win10.default = Win10;
